import { render, staticRenderFns } from "./tbxbfhxsc.vue?vue&type=template&id=7a4cbe2e&scoped=true&"
import script from "./tbxbfhxsc.vue?vue&type=script&lang=js&"
export * from "./tbxbfhxsc.vue?vue&type=script&lang=js&"
import style0 from "./tbxbfhxsc.vue?vue&type=style&index=0&id=7a4cbe2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cbe2e",
  null
  
)

export default component.exports